import { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'

import { getApplication, updateApplication } from '../../api/applications.js'
import ApplicationForm from '../../components/applications/ApplicationForm.jsx'

export default function ApplicationEditPage() {
  const { id } = useParams()
  const hasValidId = Boolean(id)
  const navigate = useNavigate()
  const [state, setState] = useState({
    status: 'loading',
    data: null,
    error: null,
  })
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [submitError, setSubmitError] = useState(null)

  useEffect(() => {
    if (!hasValidId) return undefined

    let cancelled = false

    getApplication(id)
      .then((data) => {
        if (!cancelled) {
          setState({
            status: 'ok',
            data,
            error: null,
          })
        }
      })
      .catch((error) => {
        if (!cancelled) {
          setState({
            status: 'error',
            data: null,
            error,
          })
        }
      })

    return () => {
      cancelled = true
    }
  }, [hasValidId, id])

  async function handleSubmit(values) {
    if (!id) return

    setIsSubmitting(true)
    setSubmitError(null)

    try {
      await updateApplication(id, values)
      navigate(`/applications/${id}/configs`)
    } catch (error) {
      setSubmitError(error)
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <div className="page">
      <div className="pageHeader">
        <h1 className="pageTitle">Edit application</h1>
        <Link to={id ? `/applications/${id}` : '/applications'} className="button buttonGhost">
          Back
        </Link>
      </div>

      {!hasValidId && <pre className="codeBlock codeBlockError">Application id is required</pre>}
      {hasValidId && state.status === 'loading' && <div className="muted">Loading application...</div>}
      {hasValidId && state.status === 'error' && (
        <pre className="codeBlock codeBlockError">{String(state.error?.message || state.error)}</pre>
      )}
      {hasValidId && state.status === 'ok' && state.data && (
        <ApplicationForm
          initialValues={state.data}
          onSubmit={handleSubmit}
          submitLabel="Save changes"
          isSubmitting={isSubmitting}
          error={submitError}
        />
      )}
    </div>
  )
}
